import { withDirectives as o, openBlock as n, createElementBlock as a, vShow as r } from "vue";
import { _ as s } from "./chunks/_plugin-vue_export-helper.dad06003.js";
import './assets/EmojisAnimation.css';const m = {
  props: {
    isShowEmojiAnimation: {
      type: Boolean,
      require: !1,
      default: !1
    },
    emojiIconUrl: {
      type: String,
      require: !0
    }
  },
  data() {
    return {};
  },
  watch: {
    isShowEmojiAnimation(e) {
      e && this.showAnimation();
    }
  },
  methods: {
    showAnimation() {
      var e = document.createElement("div");
      for (let i = 0; i < 10; i++) {
        var t = document.createElement("img");
        t.src = this.emojiIconUrl, t.style.left = `${Math.round(Math.random() * 95)}%`, t.style["animation-delay"] = `${Math.random()}s`, t.classList.add("frisbuy-emoji-animation__icon"), e.appendChild(t);
      }
      this.$refs.container.appendChild(e), setTimeout(() => {
        this.$refs.container && this.$refs.container.removeChild(e);
      }, 3e3);
    }
  }
}, c = {
  class: "frisbuy-emoji-animation",
  ref: "container"
};
function l(e, t, i, d, h, f) {
  return o((n(), a("div", c, null, 512)), [
    [r, i.isShowEmojiAnimation]
  ]);
}
const u = /* @__PURE__ */ s(m, [["render", l]]);
export {
  u as default
};
